import AddVideoContainer from "./AddVideoContainer";

const AddVideo = AddVideoContainer;

export default AddVideo;
